import { Megaphone } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { AnnouncementsAdminPage } from '@/pages/announcements/AnnouncementsAdminPage'
import { NoticesPage } from '@/pages/announcements/NoticesPage'
import type { AppModule } from '../moduleRegistry'

export const module: AppModule = {
  id: 'announcements',
  schoolModule: 'announcements',
  routes: {
    admin: [
      {
        path: 'announcements',
        element: (
          <RequirePermission permission="announcements.manage">
            <AnnouncementsAdminPage />
          </RequirePermission>
        ),
      },
      // Feed for admin-portal users without manage rights (e.g. accountants); linked from the topbar.
      {
        path: 'notices',
        element: (
          <RequirePermission permission="announcements.view">
            <NoticesPage homeHref="/admin" />
          </RequirePermission>
        ),
      },
    ],
    staff: [
      {
        path: 'notices',
        element: (
          <RequirePermission permission="announcements.view">
            <NoticesPage homeHref="/staff" />
          </RequirePermission>
        ),
      },
    ],
    family: [
      {
        path: 'notices',
        element: (
          <RequirePermission permission="announcements.view">
            <NoticesPage homeHref="/portal" />
          </RequirePermission>
        ),
      },
    ],
  },
  nav: {
    admin: [
      {
        group: 'Communication',
        order: 10,
        item: {
          label: 'Announcements',
          to: '/admin/announcements',
          icon: Megaphone,
          permission: 'announcements.manage',
          keywords: 'notices news broadcast notice board',
        },
      },
    ],
    staff: [
      {
        order: 30,
        item: {
          label: 'Notices',
          to: '/staff/notices',
          icon: Megaphone,
          permission: 'announcements.view',
          keywords: 'announcements news',
        },
      },
    ],
    family: [
      {
        order: 30,
        item: {
          label: 'Notices',
          to: '/portal/notices',
          icon: Megaphone,
          permission: 'announcements.view',
          keywords: 'announcements news',
        },
      },
    ],
  },
}
